export const PACKAGE_TYPES = {
  PREMIUM: 'premium',
  PLUS: 'plus',
  STANDARD: 'standard',
};

export const JURISDICTION_CHOICES = {
  UA: 'ua',
  EU: 'eu',
};

export const STEPS = {
  JURISDICTION: '1',
  DETAILS_UA: '2-1_ua',
  DETAILS_EU: '2-2_eu',
  CONSULTATION_INTL: 'consultation_intl',
  LOADING: 'loading',
  STRATEGY: '3',
  PACKAGES: '4',
  LEGAL_CHECK: '4_check',
  CALCULATION: '5',
  CHECKOUT: '6',
  SUCCESS: '/success',
  SUCCESS_PAYMENT: '/success-payment',
};

export const TOTAL_STEPS = 7;

export const stepToNumber = {
  [STEPS.JURISDICTION]: 0,
  [STEPS.DETAILS_UA]: 1,
  [STEPS.DETAILS_EU]: 1,
  [STEPS.CONSULTATION_INTL]: 1,
  [STEPS.LOADING]: 2,
  [STEPS.STRATEGY]: 2,
  [STEPS.PACKAGES]: 3,
  [STEPS.LEGAL_CHECK]: 4,
  [STEPS.CALCULATION]: 5,
  [STEPS.CHECKOUT]: 6,
};

export const stepToTitle = {
  [STEPS.JURISDICTION]: '',
  [STEPS.DETAILS_UA]: 'Деталі вашої заявки',
  [STEPS.DETAILS_EU]: 'Деталі вашої заявки',
  [STEPS.CONSULTATION_INTL]: '',
  [STEPS.LOADING]: 'Аналіз вашого бренду',
  [STEPS.STRATEGY]: 'Оберіть вашу стратегію захисту',
  [STEPS.PACKAGES]: 'Оберіть пакет послуг',
  [STEPS.LEGAL_CHECK]: 'Юридична перевірка ТМ',
  [STEPS.CALCULATION]: 'Фінальний розрахунок',
  [STEPS.CHECKOUT]: 'Оформлення заявки та оплата',
};

export const LEAD_STATUSES = {
  NEW_LEAD: 1,
  CONSULTATION: 2,
};

export const FINAL_STEP_TYPES = {
  CONSULTATION: 'consultation',
};

export const APPLICANT_COUNT = {
  ONE: 'one',
};

export const COLOR_CHOICE = {
  YES: 'yes',
};

export const SERVICE_DETAILS = {
  [PACKAGE_TYPES.PREMIUM]: {
    id: 'id_25',
    name: 'Реєстрація ТМ в Україні (Premium)',
    packageName: 'Premium',
  },
  [PACKAGE_TYPES.PLUS]: {
    id: 'id_27',
    name: 'Реєстрація ТМ в Україні (Plus)',
    packageName: 'Plus',
  },
  [PACKAGE_TYPES.STANDARD]: {
    id: 'id_24',
    name: 'Реєстрація ТМ в Україні (Standard)',
    packageName: 'Standard',
  },
};
